import { render, staticRenderFns } from "./reportsqsc.vue?vue&type=template&id=2b915e1c&scoped=true"
import script from "./reportsqsc.vue?vue&type=script&lang=js"
export * from "./reportsqsc.vue?vue&type=script&lang=js"
import style0 from "./reportsqsc.vue?vue&type=style&index=0&id=2b915e1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b915e1c",
  null
  
)

export default component.exports